import { LitElement } from 'lit-element';

export const withTemplate = Base =>
  class extends Base {
    set template(val) {
      if (val && this._val !== val) {
        this._val = val;
        this.innerHTML = val;
      }
    }
  };

export const TemplateElement = withTemplate(LitElement);

export default { TemplateElement };
